const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

export const collectTranslationKeyPaths = (value, prefix = '') => {
    if (!isPlainObject(value)) {
        return prefix ? [prefix] : []
    }

    const keys = Object.keys(value)
    if (keys.length === 0) {
        return prefix ? [prefix] : []
    }

    return keys.reduce((paths, key) => {
        const path = prefix ? `${prefix}.${key}` : key
        return paths.concat(collectTranslationKeyPaths(value[key], path))
    }, [])
}

export const stripAdminSection = (translation) => {
    if (!isPlainObject(translation)) {
        return {}
    }
    const { admin, ...rest } = translation
    return rest
}

export const unwrapAdminPayload = (translation) => {
    if (!isPlainObject(translation)) {
        return {}
    }
    if (isPlainObject(translation.admin) && !Object.prototype.hasOwnProperty.call(translation, 'title')) {
        return translation.admin
    }
    return translation
}

export const validateTranslationKeys = (translation, referenceTranslation, scope = 'user') => {
    const normalizedTranslation = scope === 'admin'
        ? unwrapAdminPayload(translation)
        : stripAdminSection(translation)
    const normalizedReference = scope === 'admin'
        ? unwrapAdminPayload(referenceTranslation)
        : stripAdminSection(referenceTranslation)

    if (!isPlainObject(normalizedTranslation)) {
        return {
            isValid: false,
            missing: collectTranslationKeyPaths(normalizedReference).sort(),
            extra: []
        }
    }

    const expected = new Set(collectTranslationKeyPaths(normalizedReference))
    const uploaded = new Set(collectTranslationKeyPaths(normalizedTranslation))
    const missing = [...expected].filter((key) => !uploaded.has(key)).sort()
    const extra = [...uploaded].filter((key) => !expected.has(key)).sort()

    return {
        isValid: missing.length === 0 && extra.length === 0,
        missing,
        extra
    }
}
